import React from 'react';
import { PermissionGuard } from '@/components/PermissionGuard';

interface ModuleAccessGuardProps {
  moduleId: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

// Legacy wrapper for backwards compatibility - use PermissionGuard directly instead
export function ModuleAccessGuard({ 
  moduleId, 
  children, 
  fallback 
}: ModuleAccessGuardProps) {
  return (
    <PermissionGuard resource={moduleId} fallback={fallback}>
      {children}
    </PermissionGuard>
  );
}